import { useEffect, useState } from "react";
import { NavLink as Link } from "react-router-dom";

import Animation from "@/components/Animation";
import Spinner from "@/components/Spinner";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { convertText, isTeacher } from "@/hooks/utils";
import { useAppSelector } from "@/store/hooks";
import { CheckCircle, Lock, Play } from "lucide-react";

export enum lessonsTypeEnum {
  RECORDED = "recorded",
}

const formatDate = (dateString: string) => {
  // Create a Date object from the string
  const date = new Date(dateString.replace(" ", "T")); // Replace space with 'T' for ISO format

  const formattedDate = date.toLocaleString("ar-EG", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });

  return formattedDate; // Output: "July 29, 2023, 19:36:53"
};

const LiveLessonsList = () => {
  //   const { schoolgrade, group } = useParams();

  const [isMobile, setIsMobile] = useState(false);
  const { portal, userProfileData } = useAppSelector((state) => state.store);
  const lessons = portal?.data.filter((item) => item.is_live_session);
  //   const catName = portal?.cats?.filter(
  //     (item) => decodeURIComponent(item.slug) === decodeURIComponent(group)
  //   )?.[0]?.name;

  const checkIsPurchased = (lectureId: string) => {
    return userProfileData?.purchases?.find(
      (purchase) => Number(purchase) === Number(lectureId)
    );
  };

  useEffect(() => {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    setIsMobile(
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      )
    );
  }, []);

  return (
    <Animation>
      <div className="min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {!portal && <Spinner />}

          {portal && (
            <>
              {/* <div className="mb-8">
                <nav className="flex mb-4 text-sm text-gray-600">
                  <Link
                    to={`/${schoolgrade}/groups`}
                    className="hover:text-blue-600 capitalize"
                  >
                    {catName.indexOf("|") > -1
                      ? catName.split("|")[0]
                      : catName}
                  </Link>
                  <span className="mx-2">/</span>
                  <span className="capitalize">{group?.replace("-", " ")}</span>
                </nav>

                <h1 className="text-3xl font-bold text-gray-900 mb-2 capitalize">
                  {catName.indexOf("|") > -1 ? catName.split("|")[0] : catName}
                </h1>
              </div> */}

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {lessons?.length ? (
                  [...lessons].reverse().map((lecture) => {
                    const isPurchased = checkIsPurchased(lecture.ID);
                    const group = portal?.cats?.find(
                      (item) =>
                        Number(item.term_taxonomy_id) ===
                        Number(lecture.term_taxonomy_id)
                    );
                    const schoolGrade = portal?.cats?.find(
                      (item) =>
                        Number(item.term_taxonomy_id) === Number(group?.parent)
                    );
                    return (
                      <Card
                        key={lecture.ID}
                        className="hover:shadow-lg transition-shadow duration-200"
                      >
                        <CardHeader>
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <CardTitle className="text-xl mb-2 flex gap-2 items-center">
                                {isPurchased ? (
                                  true ? (
                                    <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                                  ) : (
                                    <Play className="w-5 h-5 text-blue-600 mr-2" />
                                  )
                                ) : (
                                  <Lock className="w-5 h-5 text-gray-400 mr-2" />
                                )}
                                {convertText(lecture.post_title)}
                              </CardTitle>
                              <p className="text-gray-600 text-sm">
                                تاريخ النشر : {formatDate(lecture.post_date)}
                              </p>
                            </div>

                            {!isTeacher() && (
                              <div className="ml-4">
                                {isPurchased ? (
                                  <Badge
                                    variant="default"
                                    className="bg-green-100 text-green-800"
                                  >
                                    مفتوح
                                  </Badge>
                                ) : (
                                  <Badge
                                    variant="secondary"
                                    className="bg-red-100 text-red-800"
                                  >
                                    مغلق
                                  </Badge>
                                )}
                              </div>
                            )}
                          </div>
                        </CardHeader>

                        <CardContent>
                          <div className="space-y-4">
                            <div className="flex space-x-2">
                              {isPurchased || isTeacher() ? (
                                <Link
                                  to={`/${schoolGrade?.slug}/${group?.slug}/live/${lecture.post_name}`}
                                  className="w-full"
                                >
                                  <Button
                                    className="flex-1 w-full hover:cursor-pointer"
                                    type="button"
                                  >
                                    إدخل الحصة
                                  </Button>
                                </Link>
                              ) : (
                                <Link
                                  to={`/${schoolGrade?.slug}/${group?.slug}/live/${lecture.post_name}`}
                                  className="w-full"
                                >
                                  <Button
                                    type="button"
                                    className="flex-1 bg-gray-100 hover:cursor-pointer w-full"
                                    variant="outline"
                                  >
                                    {lecture.hide_lesson_price
                                      ? `اشتري الآن`
                                      : `اشتري الآن - ${lecture._regular_price} جنيه`}
                                  </Button>
                                </Link>
                              )}
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    );
                  })
                ) : (
                  <p className="text-center text-gray-500 col-span-2">
                    لا توجد حصص لايف حالياً.
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </Animation>
  );
};

export default LiveLessonsList;
